import { apiFetch } from "./api";
import { OhioEmployerListResponse, OhioEmployerDetailResponse } from "../types/fyo";

export interface InfluencedPlacementFilters {
  status?:          string;
  name?:            string;
  window_expired?:  boolean;
  limit?:           number;
  offset?:          number;
}

export function fetchOhioEmployerDetail(rms_candidate_id: number | string): Promise<OhioEmployerDetailResponse> {
  return apiFetch(`/ohio/employers/${rms_candidate_id}`);
}

export function fetchOhioEmployers(filters: InfluencedPlacementFilters = {}): Promise<OhioEmployerListResponse> {
  const q = new URLSearchParams();
  if (filters.status)                 q.set("status",         filters.status);
  if (filters.name)                   q.set("name",           filters.name);
  if (filters.window_expired != null) q.set("window_expired", String(filters.window_expired));
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/ohio/employers?${q}`);
}
